module.exports = __webpack_public_path__ + "static/media/moreIcon.825776a8.svg";